import React from 'react';
import { Grid, Link, Typography } from '@mui/material';

export function Hero() {
    return (
        <Grid container display="flex" justifyContent="space-between" alignItems="center">
                <Grid item xs={12} sm={7} order={{ xs: 2, sm: 1 }}>
                    <Typography
                        variant="h4"
                        component="h1"
                        sx={{
                            marginBottom: { xs: '12px', sm: '16px' },
                            color: '#1e293b',
                        }}
                    >
                        Hi! I'm Damon 👋🏼
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        component="p"
                        sx={{ marginBottom: { xs: '12px', sm: '16px' }, color: '#334155' }}
                    >
                        I'm a <Link href="https://linkedin.com/in/damonye">senior software engineer</Link> based in New York City,
                        currently building things at <Link href="https://linkedin.com">LinkedIn</Link>.
                        Previously at <Link href="https://amazon.com">Amazon</Link> and <Link href="https://grubhub.com">Grubhub</Link>.
                    </Typography>
                    <Typography variant="subtitle1" component="p" sx={{ color: '#334155' }}>
                        Outside of work, you'll find me playing board games 🎲, reading 📚, on the tennis court 🎾,
                        exploring new places 🌎, trying new foods 🍱, tinkering with everything 🔨, or
                        watching a seemingly endless amount of content 📺.
                    </Typography>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={4}
                    display="flex"
                    order={{ xs: 1, sm: 2 }}
                    marginBottom={{ xs: '32px', sm: '0' }}
                    justifyContent={{ xs: 'center', sm: 'flex-end' }}
                >
                    <img
                        src="/profile-picture.png"
                        alt="Damon Ye"
                        style={{
                            borderRadius: '50%',
                            height: '240px',
                            width: '240px',
                            boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
                            border: '4px solid white',
                        }}
                    />
                </Grid>
        </Grid>
    )
}